module.exports = __webpack_public_path__ + "static/media/vpl-logo.dc70fcd5.png";